import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/material/integrations/interoperability/interoperability.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
